import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { RouterModule } from '@angular/router';
import { ImageModule } from '../_shared/image/image.module';



@NgModule({
    declarations: [HeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    ImageModule,
  ],
    exports: [
        HeaderComponent
    ]
})
export class HeaderModule { }
